<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 项目相关</el-breadcrumb-item>
                <el-breadcrumb-item> 新版项目信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item prop='dictType' style='margin-bottom: 0'>
                                <el-input
                                    size='mini'
                                    v-model='queryParams.name'
                                    clearable
                                    placeholder='请输入项目名称'
                                    style='width: 240px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select size='mini' v-model='queryParams.status' placeholder='请选择项目状态'>
                                    <el-option
                                        v-for='item in projectInfoStatusList'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                        <el-row class='mb8'>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-plus'
                                    plain
                                    size='mini'
                                    type='primary'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='projectInfoList'
                      @selection-change='handleSelectionChange'>
                <!--<el-table-column align='center' type='selection' width='55' />-->
                <el-table-column align='center' label='名称' prop='name' />
                <el-table-column align='center' label='中文名' prop='cnName' />
                <el-table-column align='center' label='版权信息' :show-overflow-tooltip='true' prop='copyrightMsg' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='appId' prop='appId' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='状态'>
                    <template slot-scope='scope'>
                        <el-tag size='mini' :type='getProjectInfoStatusType(scope.row.status)'>
                            {{ getProjectInfoStatus(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='创建时间' prop='createTime' />
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :before-close='cancel' :visible.sync='open' append-to-body width='40%'>
                <el-form label-position='right' ref='form' label-width='100px'>
                    <el-form-item label='项目中文名' prop='url'>
                        <el-input size='mini' v-model='currentProjectInfo.cnName' placeholder='请输入项目中文名' />
                    </el-form-item>
                    <el-form-item label='项目名' prop='url'>
                        <el-input size='mini' v-model='currentProjectInfo.name' placeholder='请输入项目名' />
                    </el-form-item>
                    <el-form-item label='项目Icon' prop='url'>
                        <cotton-file-upload :data='projectFileInfo'
                                            ref='file'
                                            :custom-trigger='true'
                                            @fileUploadSuccess='handleFileUploadSuccess'
                                            :show-file-list='false'
                                            trigger-type='text'
                                            accept='image/*' :auto-upload='true'>
                            <template #trigger>
                                <el-avatar shape="square" size='large' :src='projectIcon' alt='点击更新项目icon'></el-avatar>
                            </template>
                        </cotton-file-upload>
                    </el-form-item>
                    <el-form-item label='项目状态' prop='url'>
                        <el-select size='mini' v-model='currentProjectInfo.status' placeholder='请选择'>
                            <el-option
                                v-for='item in projectInfoStatusList'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <cotton-dynamic-form @getDynamicJsonString='getDynamicJsonString' :json-object='currentProjectInfo' json-key='copyrightMsg'/>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
            
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deleteWhiteUrl } from '@/components/api/white';
import { deepCopy } from '@/utils/object';
import {
    deleteProjectInfo,
    insertProjectInfo,
    queryProjectInfoList,
    updateProjectInfo
} from '@/components/api/ProjectInfo';
import CottonFileUpload from '@/components/component/CottonFileUpload.vue';
import CottonDynamicForm from '@/components/component/CottonDynamicForm.vue';

export default {
    name: 'Dict',
    components: { CottonDynamicForm, CottonFileUpload },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                name: undefined,
                status: undefined
            },
            updateStatus: false,
            projectInfoStatusList: [
                {
                    label: '已删除',
                    value: 0
                },
                {
                    label: '已上线',
                    value: 1
                },
                {
                    label: '开发中',
                    value: 2
                },
                {
                    label: '测试中',
                    value: 3
                },
            ],
            
            projectInfoList: [],
            currentProjectInfo: {
                icon: undefined,
                copyrightMsg: undefined
            },
            projectFileInfo: {
                ownerType: 'GAME_PROJECT',
                accessType: 'PUBLIC',
                saveFolder: '/project/icon'
            },
            projectIcon: undefined
        };
    },
    watch: {
        treeFilterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    computed: {
        getProjectInfoStatusType() {
            return (status) => {
                switch (status) {
                    case 1:
                        return 'success';
                    case 3:
                        return 'info';
                    case 2:
                        return 'warning';
                    case 0:
                        return 'danger';
                }
            };
        },
        getProjectInfoStatus() {
            return (status) => {
                switch (status) {
                    case 0:
                        return '已删除';
                    case 1:
                        return '已上线';
                    case 2:
                        return '开发中';
                    case 3:
                        return '测试中';
                }
            };
        },
        getWarningLevelType() {
            return (level) => {
                switch (level) {
                    case 'HIGH':
                        return 'danger';
                    case 'MIDDLE':
                        return 'warning';
                    case 'LOW':
                        return 'info';
                }
            };
        },
        getWarningLevelMsg() {
            return (level) => {
                switch (level) {
                    case 'HIGH':
                        return '一级预警';
                    case 'MIDDLE':
                        return '二级预警';
                    case 'LOW':
                        return '三级预警';
                }
            };
        }
    },
    created() {
        this.getList();
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        /** 查询字典类型列表 */
        getList() {
            this.loading = true;
            queryProjectInfoList(this.queryParams).then(response => {
                    if (response.code === 200) {
                        this.projectInfoList = response.data.result;
                        this.queryParams.total = response.data.total;
                        this.loading = false;
                        this.queryParams.pageNum = response.data.pageNum;
                    } else {
                        this.loading = false;
                    }
                }
            );
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
            this.$refs.file.initFileList()
            this.currentProjectInfo = {
                icon: undefined,
                copyrightMsg: undefined
            }
        },
        // 表单重置
        reset() {
            this.projectIcon = undefined
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {};
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = '增加后端接口';
            this.updateStatus = false;
            this.currentProjectInfo = {
                icon: undefined,
                copyrightMsg: undefined
            };
        },
        handleBatchDelete() {
            let idList = this.ids;
            const obj = this;
            this.$modal.confirm(`是否删除 ${idList.length} 条数据?`).then(function() {
                return deleteWhiteUrl(idList);
            }).then(result => {
                if (result.code === 200) {
                    message.success('删除成功');
                    obj.getList();
                    return;
                }
            });
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            this.open = true;
            this.title = '修改项目信息';
            this.updateStatus = true;
            this.currentProjectInfo = deepCopy(row);
            this.projectIcon = row.icon
        },
        /** 提交按钮 */
        submitForm: function() {
            this.currentProjectInfo.icon = this.projectIcon
            if (this.updateStatus) {
                updateProjectInfo(this.currentProjectInfo).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                    }
                });
            } else {
                if (!this.currentProjectInfo.name) {
                    message.warning('项目名不能为空');
                    return;
                }
                insertProjectInfo(this.currentProjectInfo).then(result => {
                    if (result.code === 200) {
                        message.success('添加成功');
                        this.getList();
                        this.open = false;
                    }
                });
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + row.name + '"项目？').then(function() {
                return deleteProjectInfo({ id: row.id });
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        handleFileUploadSuccess(file) {
            this.projectIcon = file.url
        },
        
        getDynamicJsonString(setting) {
            this.currentProjectInfo.copyrightMsg = setting
        }
    }
};
</script>
<style>

</style>